import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStyles } from '../../styles/styles';

const StyledComponent = observer(
  ({ component: Component = 'div', children, className = '', ...props }: any) => {
    const classes = useStyles();

    return (
      <Component className={`${classes.styledWithMargin} ${className}`} {...props}>
        {children}
      </Component>
    );
  },
);

export default StyledComponent;
